import { useAuth0 } from '@auth0/auth0-react';
import { SnackbarProvider } from 'notistack';
import React, { useState } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { AppContext, AppContextDefaultValue } from './contexts/AppContext';
import './scss/style.scss';

const loading = (
  <div className='pt-3 text-center'>
    <div className='sk-spinner sk-spinner-pulse'></div>
  </div>
);

const TheLayout = React.lazy(() => import('./containers/TheLayout'));
const Login = React.lazy(() => import('./views/auths/Login'));
const Fix = React.lazy(() => import('./views/fix/Fix'));

const App = () => {
  const [appContextValue, setAppContextValue] = useState(
    AppContextDefaultValue
  );

  const { isLoading, isAuthenticated, error } = useAuth0();

  if (isLoading) {
    return <div style={{ padding: 15 + 'px' }}>Loading...</div>;
  }
  if (error) {
    return <div style={{ padding: 15 + 'px' }}>Oops... {error.message}</div>;
  }

  return (
    <BrowserRouter>
      <React.Suspense fallback={loading}>
        <AppContext.Provider value={{ ...appContextValue, setAppContextValue }}>
          <SnackbarProvider
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
            style={{ maxWidth: '100px' }}
          >
            <Switch>
              <Route
                exact
                path='/login'
                name='Login Page'
                render={(props) => <Login {...props} />}
              />
              <Route
                exact
                path='/fix'
                name='Fix'
                render={(props) => <Fix {...props} />}
              />
              <Route
                path='/'
                name='Home'
                render={(props) => <TheLayout {...props} />}
              />
            </Switch>
          </SnackbarProvider>
        </AppContext.Provider>
      </React.Suspense>
    </BrowserRouter>
  );
};

export default App;
